import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../../assets/styles/modules/SummaryCardLayout.module.css";
import styled from "styled-components";
import news from "../../../assets/images/ico_news.png";
import company from "../../../assets/images/ico_company.png";

const CardContainer = styled.div`
  background-color: ${(props) => props.bg};
  padding: ${(props) => props.padding};
  color: ${(props) => (props.bg === "#fff" ? "#222" : "#fff")};
`;
const SummaryCardDiv = styled.div`
  display: inline-block;
  position: relative;
  margin-right: 12px;
  width: 114px;
  height: 128px;
  padding: 16px;
  border-radius: 15px;
  cursor: default;
  background-color: ${(props) => props.bgcolor};
  &.border[class~="positive"]:hover {
    border: solid 2px #f86e8e;
  }
  &.border[class~="negative"]:hover {
    border: solid 2px #3d6ae6;
  }
  &.background:hover {
    background-color: #fff;
  }
  @media (max-width: 660px) {
    &:last-child {
      display: none;
    }
  }
  @media (max-width: 500px) {
    &:nth-child(n + 4) {
      display: none;
    }
  }
`;

const SummaryCardLayout = ({ stockList, stockList_n, bg, padding, type }) => {
  const navigate = useNavigate();

  const searchRange = () => {
    switch (type) {
      case "기업":
        return stockList.map((stock) => stock.stockcode);
      case "산업":
        return stockList.map((stock) => stock.FICS_sub);
      case "테마":
        return stockList.map((stock) => stock.themecode);
    }
  };

  const searchRange_n = () => {
    switch (type) {
      case "기업":
        return stockList_n.map((stock) => stock.stockcode);
      case "산업":
        return stockList_n.map((stock) => stock.FICS_sub);
      case "테마":
        return stockList_n.map((stock) => stock.themecode);
    }
  };

  const moveToNews = (react, title) => {
    const range = react === "positive" ? searchRange() : searchRange_n();
    const type_en =
      type === "기업" ? "finance" : type === "산업" ? "industry" : "theme";
    navigate(`/news/${type_en}/${react}`, {
      state: { type: type, title: title, range: range.join("|") },
    });
  };

  const moveToStock = (stockcode) => navigate(`/stock/${stockcode}`);

  const SummaryCard = ({ stock, bgcolor, react, hover }) => {
    if (type === "산업") {
      return (
        <SummaryCardDiv bgcolor={bgcolor} className={`${react} ${hover}`}>
          <p className={styles.stockname}>{stock.FICS_sub}</p>
          <p className={styles.stock_count}>
            <img className={styles.icon} src={company} alt="icon" />
            <span>관련기업 {stock.FICS_sub_stockcnt}개</span>
          </p>
          <p className={styles.news_count}>
            <img className={styles.icon} src={news} alt="icon" />
            <span>뉴스 {stock.FICS_sub_ncnt}개</span>
          </p>
        </SummaryCardDiv>
      );
    } else if (type === "테마") {
      return (
        <SummaryCardDiv bgcolor={bgcolor} className={`${react} ${hover}`}>
          <p className={styles.stockname}>{stock.themename}</p>
          <p className={styles.stock_count}>
            <img className={styles.icon} src={company} alt="icon" />
            <span>관련기업 {stock.themestockcnt}개</span>
          </p>
          <p className={styles.news_count}>
            <img className={styles.icon} src={news} alt="icon" />
            <span>뉴스 {stock.themencnt}개</span>
          </p>
        </SummaryCardDiv>
      );
    } else {
      return (
        <SummaryCardDiv bgcolor={bgcolor} className={`${react} ${hover}`}>
          <p
            className={styles.stockname}
            onClick={() => moveToStock(stock.stockcode)}
          >
            {stock.stockname}
          </p>
          <p className={styles[react]}>
            {react === "positive" ? "▲" : "▼"}
            {stock.gappercent}%
          </p>
          <p
            className={styles.news_count}
            onClick={() =>
              moveToNews(react, react === "positive" ? "양의기업" : "음의기업")
            }
          >
            <img className={styles.icon} src={news} alt="icon" />
            <span>뉴스 {stock.n_cnt}개</span>
          </p>
        </SummaryCardDiv>
      );
    }
  };

  return (
    <>
      <CardContainer bg={bg} padding={padding}>
        <div className={`${styles.inner_container} ${styles.main_layout}`}>
          <div className={styles.positive_area}>
            <div className={styles.flex_layout}>
              <span className="title_sm">주요 상승 {type}</span>
              <span
                className="click"
                onClick={() => moveToNews("positive", `양의${type}`)}
              >
                전체 리스트 〉
              </span>
            </div>
            <div className={styles.stockList}>
              {!!stockList &&
                stockList.map((stock, idx) => (
                  <SummaryCard
                    key={idx}
                    stock={stock}
                    bgcolor={type === "산업" ? "#fff" : "#fdecec"}
                    react="positive"
                    hover={type === "테마" ? "background" : "border"}
                  />
                ))}
            </div>
          </div>
          <div className={styles.negative_area}>
            <div className={styles.flex_layout}>
              <span className="title_sm">주요 하락 {type}</span>
              <span
                className="click"
                onClick={() => moveToNews("negative", `음의${type}`)}
              >
                전체 리스트 〉
              </span>
            </div>
            <div className={styles.stockList}>
              {!!stockList_n &&
                stockList_n.map((stock, idx) => (
                  <SummaryCard
                    key={idx}
                    stock={stock}
                    bgcolor={type === "산업" ? "#fff" : "#ecf0fd"}
                    react="negative"
                    hover={type === "테마" ? "background" : "border"}
                  />
                ))}
            </div>
          </div>
        </div>
      </CardContainer>
    </>
  );
};

export default SummaryCardLayout;
